import MobileBottomNav from "../components/MobileBottomNav";
import MobileFooter from "../components/MobileFooter";
import MobileHeader from "../components/MobileHeader";
import "../styles/mobile-theme.css";
import "../styles/mobile-search-redesign.css";
import "../styles/mobile-footer-redesign.css";

export default function MobileLayout({ children, showFooter = false, showBottomNav = true }) {
  return (
    <div className="hv-mobile-shell">
      <MobileHeader />
      <main className={`hv-mobile-main ${showFooter ? "with-footer" : ""}`}>{children}</main>
      {showFooter ? <MobileFooter /> : null}
      {showBottomNav ? <MobileBottomNav /> : null}
    </div>
  );
}
